$(function() {
	// // Main Homepage Slider
	// $('.main-slider').bxSlider({
		
	// });
	// Product Slider
	$('.slider').bxSlider({
		auto: 'true',
		slideMargin: '10',
		infiniteLoop: 'true',
		useCSS: 'false',  
		touchEnabled: 'true'
	});
	//Sale Notifier on home page below navigation
	//$( ".ship-note-wrap .close" ).click(function() {
	//	$( ".ship-note-wrap" ).slideUp();
	//});
	//$('input:checkbox').screwDefaultButtons({
	//	image: "url(https://cdn.shopify.com/s/files/1/0698/0337/t/3/assets/_action-check-p-2.png)",
	//	width: 36,
	//	height: 36
	//});
  	// Hide Checkbox without JS
  	$('.styledcheckbox_basic').addClass('styledcheckbox_basic_show');
  	$('.service_hidenojs').removeClass('service_hidenojs');
	// Selected Filter Tags 
	$(".tag-del").mouseover(function(){
		$(this).siblings(".tag-selected").addClass("seleced-hover");
	});
	$(".tag-del").mouseleave(function(){
		$(".tag-selected").removeClass("seleced-hover");
	});
	// Look for Quantity Break Pricing div and check if it has anyhing inside
	// If True, display .show-case div 
	setTimeout(function() {
		// console.log($('.shappify_qb_grid').text().length);
    	if ($('.shappify_qb_grid').text().length > 0) {
    		$(".tennis-case").addClass("show-case");
		} else {
			$(".tennis-case").removeClass("show-case");
		}
	}, 1000);
	// initializes Product Accordion and removes Tab elements
	var accordionMaker = function() {
		$( '.prodInfoAccordion' ).accordion({
			collapsible: true,
			active: false,
			heightStyle: "content"
		});
	};
	accordionMaker();
	// Opens stringing Options Modal if checkbox is checked
	$('#stringservice').change(function () {
        if ($(this).is(':checked')) {
          	$("#bundle_id").insertAfter("#bundleIN");
            $(".stringing-options-modal").addClass('showModal');
          	$("#wishlist_wrap").addClass('hide_wrap');
          	$("#demo_wrap").addClass('hide_wrap');
        } else {
          	$("#bundle_id").insertAfter("#bundleOUT");
 			$(".stringing-options-modal").removeClass('showModal');
          	$("#wishlist_wrap").removeClass('hide_wrap');
          	$("#demo_wrap").removeClass('hide_wrap');
        }
    });
  	$('#giftwithpurchase').change(function () {
        if ($(this).is(':checked')) {
          	$("#gift_id").insertAfter("#bundleIN");
        } else {
          	$("#gift_id").insertAfter("#bundleOUT");
        }
    });
  	$('#giftwrapservice').change(function () {
        if ($(this).is(':checked')) {
          	$("#gift_wrapping").insertAfter("#bundleIN");
        } else {
          	$("#gift_wrapping").insertAfter("#bundleOUT");
        }
    });
    $(".stringing-options-content .cancel-ss").click(function() {
		//Closes Modal
		$(".stringing-options-modal").removeClass('showModal');
		//Unchecks Stringing Service checkbox if cancel is clicked
		$('#stringservice').prop('checked', false);
		//Screw Defalt Styles Fix for unchecked checkbox
		$('#stringservicebox .styledCheckbox').css('background-position', '0px 0px');
	});
	$(".stringing-options-content .atc-ss").click(function() {
		//Closes Modal
		$(".stringing-options-modal").removeClass('showModal');
	});
	// Removes the Specification table from the Description and puts it in its own tab
	var specExtractor = function() {
		$("#description table").insertAfter(".spec-insert");
	};
	specExtractor();
	// Removes the <ul> tag from the product description and puts it in its own tab
	var ulExtractor = function() {
		$(".prodInfoTabs #description .prod_spec").insertAfter(".spec-insert");
	};
      if ($(".prod_spec")[0]) {
          ulExtractor();
      }
      else {
          $(".specifications-tab").css("display", "none")
      }
	var ulExtractorM = function() {
		$(".prodInfoAccordion #description .prod_spec").insertAfter(".spec-insert-2");
	};
        if ($(".prod_spec")[0]) {
          	ulExtractorM();
      }
      else {
          $(".specifications-tab").css("display", "none")
      }
  
  	// Moves Extra Fit Info to Fit Guide tab
	var ulFITExtractor = function() {
		$(".prodInfoTabs #description .prod_fit").insertAfter(".fit-insert");
	};
      if ($(".prod_fit")[0]) {
          ulFITExtractor();
      }
	var ulFITExtractorM = function() {
		$(".prodInfoAccordion #description .prod_fit").insertAfter(".fit-insert-2");
	};
        if ($(".prod_fit")[0]) {
          	ulFITExtractorM();
      }

	// Repositions Filters on Desktop
	var filterMover = function() {
		$(".filters").insertAfter(".filter-after");
	};
	$(".accord-review:first-child").addClass("first-rating");
	//Make Spotlight SLider
	var slSlider = function() {
		$('.spotlight-slider').bxSlider({
			auto: 'true',
			slideMargin: '10',
			infiniteLoop: 'true',
			useCSS: 'false',  
			touchEnabled: 'true'
		});
	};
	slSlider();
	// Renames class to avoid desktop css
	var classRenamer = function() {
		$(".main-product-wrap").attr('class', 'main-product-wrap-mobile');
	};
	//Moves Add To Card Button
	var atcTeleport = function() {
		$( ".addToCartBtn" ).insertAfter( ".prod-info .clear" );	
	};
	// Pulls Description title out of accordion
	var descTitleExtractor = function() {
		$( ".description-title" ).insertAfter( ".stringing-options" );
	};
	// Repositions Options div
	var optionMover = function() {
		$( ".prod-options" ).insertAfter( ".pull-me-out" );
	};
	// Puts tabs in correct position for desktop
	var tabExtractor = function() {
		$( ".prodInfoAccordion .tabs" ).insertBefore( ".description-title" );
	};	
	$( "#mm-mainNav ul li:last-child a" ).addClass("top-lvl-services");
	//add recommended tension range to tension pick up tab
	
	var prodMiniSpec = function() {
		var miniSpec = $('.prod_minispec').html();
		$('.mini-spec-wrap').append(miniSpec);
		// console.log(miniSpec);
	};

	if ($('#description').find('.prod_minispec').length) {
		prodMiniSpec();
      	$('.mini-spec-wrap').css("display", "inline-block");
	} else {
		$('.mini-spec-wrap').css("display", "none");
	}
	
	var ratingCloner = function() {
		//var prodRat = document.getElementsByClassName('spr-summary-starrating')[0].innerHTML;
		//document.getElementsByClassName('rating-wrap')[0].innerHTML = prodRat;      
	};
	if ($('.spr-summary-starrating').length) {
		ratingCloner();
	}
	
	var prodTechFunc = function() {
		var prodTech = $('.prodInfoTabs .prod_tech').html();
		$('.prodInfoTabs .show-tech').append(prodTech);
		var prodTech = $('.prodInfoAccordion .prod_tech').html();
		$('.prodInfoAccordion .show-tech-2').append(prodTech);
	};

	if ($("#description").find(".prod_tech").length) {
		prodTechFunc();
	} else {
		$(".technology-tab").css("display", "none")
	}

	$('.thumbs .image a img').click(function() {
		var newAlt = $(this).attr("alt");
      	var currTitle = document.getElementById("prod-title").innerText;
      	if (newAlt != currTitle) {
		$(".prod-pics .colour-display").text(newAlt);                   
        } else {
        $(".prod-pics .colour-display").text("");  
        }
	})

	// IE 9 ADDCLASS
	$("select").parent().addClass("selectParent");
  
  	// Repositions Reviews to Desktop
	var reviewMover = function() {
		$("#review-mover").insertBefore("#review-dtop");
	};
  	

	///////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////// Reverse Functions//////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////
	
  	// Repositions Reviews to Mobile
	var r_reviewMover = function() {
		$("#review-mover").insertBefore("#review-mobile");
	};
  	// initializes Product Tabs and inserts Tab elements
	var accordionBreaker = function() {
		$('.tabs').insertAfter('.stringing-options');
		$( '.prodInfoAccordion' ).accordion({
			collapsible: true,
			active: false,
			heightStyle: "content"
		});
	};
	// Repositions Filters on Tablet and Mobile
	var r_filterMover = function() {
		$(".filters").insertAfter(".page-titler");
	};
	// Renames class to catch desktop css
	var r_classRenamer = function() {
		$(".main-product-wrap-mobile").attr('class', 'main-product-wrap');
	};
	var r_atcTeleport = function() {
		$( ".atc-wrap" ).append( $(".addToCartBtn") );
	};
	var r_descExtractor = function() {
		$( ".pull-me-out" ).insertAfter( ".prodInfoAccordion .pull-me-out-handle" );
	};
	var r_optionMover = function() {
		$( ".prod-options" ).insertAfter( ".prod-info" );
	};
	//Destroys Spotlight SLider
	var slSliderDestroyer = function() {
		slider = $('.spotlight').bxSlider();
		slider.destroySlider();
	};
  	//Close mmenu  	
  	
	///////////////////////////////////////////////////////////////////////////////////////////////
	///////////////////// Desktop Only ////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////
	if ($(window).width() > 1024){
		
		// Desktop tabs for product description
		$( ".prodInfoTabs" ).tabs();
		$( ".accordionSection" ).removeClass( "pull-me-out" );
      	reviewMover();
	}

	if ($(window).width() > 1240){
		//filterMover();
      	// Remove all anchors from to level navigation
		//$("#mainNav > .container > ul.horizontal > li.dropdown > a").attr({
		//	href: "",
		//	onclick: "return false"
		//});

		//$("body").click(function() {
		//    $('li.dropdown').removeClass("dd-active");
		//});

		//$(".dropdown-inner").click(function(e) {
		//    e.stopPropagation();
		//});

		//Initiate hover dropdown effect upon click and remove from hover
		//$('#mainNav16 > ul > li').on('click',function(e) {
			//e.stopPropagation();
			// console.log($(this).parent().hasClass('dd-active'));
			//if ($("ul.dropdown").hasClass("dd-active")) {
				//$("ul.dropdown").removeClass("dd-active");
				//$('ul.horizontal > li > a').removeClass("active-nav");
			//}
			
			//if($(this).parent().hasClass('dd-active')){
				//$('li.dropdown').removeClass("dd-active");
				
			//}
			//else{
				//$('li.dropdown').removeClass("dd-active");
				//$(this).parent().addClass("dd-active");

			//}
			// $(this).toggleClass("active-nav");
		//});

		//$("li.dropdown").on("click", function(event) {
			// event.preventDefault();
			// $(".dropdown").removeClass("dd-active");
		 // 	$(this).removeClass("active-nav");
		    // console.log("active");
		//});
	}

	///////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////// TABLET ONLY////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////
	if ($(window).width() > 767 && $(window).width() < 1025) {
      	r_reviewMover();
	}
	///////////////////////////////////////////////////////////////////////////////////////////////
	///////////////////// Mobile Only/////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////
	if ($(window).width() < 768){
		//Mobile sidebar 
		$( ".sideBarNav .ll-title" ).click(function() {
			$(this).siblings("ul").slideToggle();
		});
      	r_reviewMover();
	}
	///////////////////////////////////////////////////////////////////////////////////////////////
	///////////////////RESPONSIVE CONDITION////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////
	var $window = $(window);
	var lastWindowWidth = $window.width();

	$window.resize(function () {
    var windowWidth = $window.width();
    if (lastWindowWidth !== windowWidth) {      	
        if ($(window).width() < 1025) {
          r_reviewMover();
          classRenamer();
		} else {
			r_classRenamer();
          	reviewMover();
			$( ".prodInfoTabs" ).tabs();			
			$( ".accordionSection" ).removeClass( "pull-me-out" );
		}
        lastWindowWidth = windowWidth;
    }
	});
})